// Every link, in one place. Feeds /links, which has no menu item of its
// own and is reached from the footer.
//
// The label is the link; raw URLs are never shown. Anything without a link is
// left out entirely rather than sitting there as a dead entry.

export const reference = {
  sections: [
    {
      title: 'The film',
      items: [
        { label: 'thegirlandherpiano.com', url: 'https://www.thegirlandherpiano.com' },
        { label: 'Full film on YouTube', url: 'https://www.youtube.com/watch?v=vSgM75wn9Mo' },
        { label: 'Trailer', url: 'https://youtu.be/sC02BQza_YU' },
        { label: 'PBS', url: 'https://www.pbs.org/video/the-girl-and-her-piano-il4or1/' },
        { label: 'IMDb', url: 'https://www.imdb.com/title/tt37798371/' },
        { label: 'Instagram', url: 'https://www.instagram.com/thegirlandherpiano' },
        { label: 'Facebook', url: 'https://www.facebook.com/thegirlandherpiano' },
        { label: 'FilmFreeway', url: 'https://filmfreeway.com/TheGirlandHerPiano' },
      ],
    },
    {
      title: 'Festivals and screenings',
      items: [
        { label: 'Cleveland International Film Festival', url: 'https://www.clevelandfilm.org/films/the-girl-and-her-piano-2026/' },
        { label: 'Colorado Environmental Film Festival', url: 'https://ceff2026.eventive.org/films/the-girl-and-her-piano-oc-6930ad933876fd39d467d1cb' },
        { label: 'International Environmental Film Festival of Chefchaouen', url: 'https://festival.assated.com' },
        { label: 'British Columbia Environmental Film Festival', url: 'https://www.bceff.org' },
        { label: 'Blue Water EduFest', url: 'https://bluewateredufest.com/' },
      ],
    },
    {
      title: 'British Columbia, the festival\u2019s weekly ten most watched',
      items: [
        { label: 'Finalist announcement', url: 'https://www.facebook.com/share/p/1GFoC1iEAn/' },
        { label: 'Week one', url: 'https://www.facebook.com/share/p/1ET46TGvio/' },
        { label: 'Week two', url: 'https://www.facebook.com/share/p/1JJcCw2h6Q/' },
        { label: 'Week three', url: 'https://www.facebook.com/share/p/19Pymc4HHQ/' },
        { label: 'Week four', url: 'https://www.facebook.com/share/p/19FGXjVK9j/' },
      ],
    },
    {
      title: 'Press',
      items: [
        { label: 'The Straits Times', url: 'https://www.straitstimes.com/life/singaporean-teen-performs-piano-piece-on-climate-change-at-cultural-festival-for-bhutan-s-king' },
        { label: 'CNA Lifestyle', url: 'https://cnalifestyle.channelnewsasia.com/entertainment/hillary-osullivan-piano-bhutan-royal-highland-festival-412231' },
        { label: 'The Asian Parent', url: 'https://sg.theasianparent.com/singaporean-teen' },
        { label: 'South China Morning Post, Young Post', url: 'https://www.scmp.com/yp/discover/lifestyle/features/article/3299512/how-14-year-old-singaporean-pianist-plays-her-part-fighting-climate-change' },
        { label: 'TODAY Online', url: 'https://www.tiktok.com/@todayonline/video/7238229770423651592' },
        // AsiaOne: the article exists, published 12 October 2024 by Joanne Soh
        // and republished from The Straits Times, but no URL has been supplied.
        // Add it here and it appears.
      ],
    },
    {
      title: 'Partners',
      items: [
        { label: 'Kerry Consulting, World Premiere', url: 'https://www.kerryconsulting.com/insights/events/the-girl-and-her-piano-premiere-october-2024/' },
        { label: 'Kerry Consulting, YouTube Premiere', url: 'https://www.kerryconsulting.com/insights/events/the-girl-and-her-piano-youtube-premiere' },
        { label: 'White Room Studio', url: 'https://www.whiteroomstudio.com.sg/blog/the-girl-and-her-piano-premieres/' },
      ],
    },
  ],
}
